import master from './master.js'
import search from './search.js'
import options from './options.js'
import signup from './signup.js'
import home from './home.js'
import chat from './chat.js'
import privateProfile from './privateProfile.js'
import publicProfile from './publicProfile.js'
import plans from './plans.js'
import contact from './contact.js'
import notifications from './notifications.js'
import terms from './terms.js'
import payments from './payments.js'
import privacyPolicy from './privacyPolicy.js'
import errors from './errors.js'

export default {
    master,
    search,
    options,
    signup,
    home,
    privateProfile,
    publicProfile,
    chat,
    plans,
    notifications,
    contact,
    terms,
    payments,
    privacyPolicy,
    errors
}
